import { HeartFilled } from '@ant-design/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Table from '../../components/Table';
import { ColumnsType } from '../../types/ColumnTypes';
import User from '../types/User';
import { useUser } from '../userContext';
import { getUserRoleText } from '../userUtils';

import UserCell from './UserCell';

type UserResultsType = {
  users?: User[];
  loading: boolean;
  getLink: (user: User) => string;
};

const UserResults: React.FC<UserResultsType> = ({
  users,
  loading,
  getLink,
}) => {
  const [currentUser] = useUser();
  const { t } = useTranslation();

  const RoleCell: React.FC<{ user: User }> = ({ user }) => (
    <div className="flex items-center justify-between">
      <div>
        {user.roles.map((role, index) => (
          <span
            key={index}
            className="px-2 inline-flex text-xs font-semibold rounded-full bg-gray-100 text-gray-800 uppercase mx-1">
            {getUserRoleText(role, t)}
          </span>
        ))}
      </div>
      <span>
        {user.id && currentUser?.favoriteInstructorIds.includes(user.id) && (
          <HeartFilled
            className="pr-3"
            style={{
              fontSize: '18px',
              color: '#FF2121',
            }}
          />
        )}
      </span>
    </div>
  );

  const columns: ColumnsType<User> = [
    {
      title: t('common.name'),
      render: (user) => <UserCell user={user} />,
    },
    {
      title: t('common.role'),
      render: (user) => <RoleCell user={user} />,
    },
  ];

  return (
    <Table
      rowKey={(user) => user.id!}
      columns={columns}
      rows={users}
      loading={loading}
      getRowLink={getLink}
    />
  );
};

export default UserResults;
